export default "__VITE_ASSET__BhrlLdt9__"